import React from 'react'


const Series = () => (
    <div>Series</div>
)

export default Series